import Vue from 'vue'
import fetch from '../plugin/fetch/index.js'
Vue.use(fetch)
let base = '/apiv1/account'

/**
 * 登录
 */
export const login = params => {
  return Vue.fetch.post(`${base}/login`, params).then(data => {
    return data
  })
}

/**
 * 退出登录
 */
export const loginout = () => {
  return new Promise((resolve, reject) => {
    Vue.fetch
      .post(`${base}/loginout`)
      .then(data => {
        window.location.href = './index.html'
      })
      .catch(data => {
        reject(data)
      })
  })
}

/**
 * 查询用户列表
 */
export const queryUserList = params => {
  return Vue.fetch.post(`${base}/queryUserList`, params).then(data => {
    return data
  })
}

/**
 * 根据部门查找用户
 */
export const queryUserByDept = params => {
  return Vue.fetch.post(`${base}/queryByDept`, params)
}

/**
 * 根据区域查找用户
 */
export const queryUserByArea = params => {
  return Vue.fetch.post(`${base}/queryByArea`, params)
}

/**
 * 添加用户
 */
export const add = params => {
  return Vue.fetch.post(`${base}/add`, params)
}

/**
 * 修改用户
 */
export const update = params => {
  return Vue.fetch.post(`${base}/update`, params)
}

/**
 * 删除用户
 */
export const remove = params => {
  return Vue.fetch.post(`${base}/remove`, params)
}

/**
 * 用户详情
 */
export const detail = params => {
  return Vue.fetch.post(`${base}/detail`, params)
}

/**
 * 重置密码
 */
export const resetPwd = params => {
  return Vue.fetch.post(`${base}/resetPwd`, params)
}

/**
 * 修改密码
 */
export const modifyPwd = params => {
  return Vue.fetch.post(`${base}/modifyPassword`, params)
}

/**
 * 冻结用户
 */
export const freeze = params => {
  return Vue.fetch.post(`${base}/freeze`, params)
}

/**
 * 解除冻结用户
 */
export const unfreeze = params => {
  return Vue.fetch.post(`${base}/unfreeze`, params)
}

/**
 * 根据用户查找部门
 */
export const getDeptsByUserId = params => {
  return Vue.fetch.post(`${base}/getDeptsByUserId`, params)
}

/**
 * 根据用户查找角色
 */
export const getRolesByUserId = params => {
  return Vue.fetch.post(`${base}/getRolesByUserId`, params)
}

/**
 * 用户分配角色
 */
export const allotRoleByUserId = params => {
  return Vue.fetch.post(`${base}/allotRoleByUserId`, params)
}

/**
 * 查询无此角色的用户
 */
export const getUsersNotInRole = params => {
  return Vue.fetch.post(`${base}/getUsersNotInRole`, params)
}

/**
 * 查询全部用户
 */
export const getAllUsers = params => {
  return Vue.fetch.post(`${base}/getAllUsers`, params)
}



// WEBPACK FOOTER //
// ./src/cdpBase/services/user.js